import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center text-center">
      <p className="font-heading text-7xl md:text-9xl font-black text-primary-100 select-none">404</p>
      <h1 className="mt-6 font-heading text-xl md:text-2xl font-bold text-foreground-900">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500">你访问的页面不存在，或链接已失效。</p>
      <div className="mt-6 flex items-center gap-3 flex-wrap justify-center">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/works"
          className="inline-flex items-center gap-2 px-5 h-10 rounded-md border border-background-300 text-foreground-700 text-sm font-label hover:border-primary-300 transition-colors whitespace-nowrap"
        >
          <i className="ri-film-line" />
          浏览影视作品
        </Link>
      </div>
    </div>
  );
}